import moment from 'moment';
import { Project } from '@/dashboard/types/project';

export function getProjectCreationDate(project: Project) {
  return moment(project.created_at).format('MM.DD.YYYY HH:mm');
}
